import { ChangeDetectorRef, Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { App } from '@df/core/app';
import { Status } from '@df/core/status';
import { Subscription } from 'rxjs/internal/Subscription';
import { StoreCreditService } from './store-credit.service';

@Directive()
export class StoreCreditToggleComponentDef implements OnInit, OnDestroy {
    status = new Status();

    protected subscriptions = new Subscription();

    @Input()
    isCheckout?: boolean;

    constructor(protected storeCredit: StoreCreditService, protected app: App, protected changeDetectorRef: ChangeDetectorRef) {}

    ngOnInit() {
        this.subscriptions.add(this.app.customer.basket.subscribe(() => this.detectChanges()));
        this.subscriptions.add(this.status.subscribe(() => this.detectChanges()));
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    get isBusy(): boolean {
        return this.status.busy;
    }

    toggle(): void {
        if (!this.isBusy) {
            if (!this.storeCredit.isAdded) {
                this.storeCredit.applyStoreCredit(this.status, this.isCheckout);
            } else {
                this.storeCredit.removeStoreCredit(this.status, this.isCheckout);
            }
        }
    }

    get balance(): number {
        return this.storeCredit.balance;
    }

    get welcomeOffer(): boolean {
        return this.storeCredit.welcomeOffer;
    }

    get used(): number {
        return this.app.customer.basket.data?.totals?.credits || 0;
    }

    protected detectChanges(): void {
        this.changeDetectorRef.detectChanges();
    }
}
